import "./Cookie.scss";
import { useState, useEffect } from "react";

const Cookie = () => {
  const [activeTab, setActiveTab] = useState("tab-cookie-1");
  const [activeCategory, setActiveCategory] = useState(-1);
  const [openSubs, setOpenSubs] = useState([-1, -1, -1]);
  const [isCookieVisible, setIsCookieVisible] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    if (typeof localStorage === "undefined") return;
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) return;
    try {
      const { timestamp } = JSON.parse(consent);
      const sixMonths = 6 * 30 * 24 * 60 * 60 * 1000;
      const isExpired = Date.now() - timestamp > sixMonths;
      if (isExpired) {
        localStorage.removeItem("cookieConsent");
        return;
      }
      setIsCookieVisible(false);
    } catch {
      // Keep banner visible if parsing fails
    }
  }, []);

  const handleCategoryClick = (index: number) => {
    setActiveCategory((prev) => (prev === index ? -1 : index));
  };

  const handleSubClick = (categoryIndex: number, subIndex: number) => {
    setOpenSubs((prev) => {
      const newSubs = [...prev];
      newSubs[categoryIndex] =
        newSubs[categoryIndex] === subIndex ? -1 : subIndex;
      return newSubs;
    });
  };

  const handleCloseCookie = () => {
    setIsCookieVisible(false);
  };

  const handleAcceptCookies = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(
        "cookieConsent",
        JSON.stringify({ status: "accepted", timestamp: Date.now() }),
      );
    }
    setIsCookieVisible(false);
  };

  const handleDeclineCookies = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(
        "cookieConsent",
        JSON.stringify({ status: "declined", timestamp: Date.now() }),
      );
    }
    setIsCookieVisible(false);
  };

  if (!isLoaded || !isCookieVisible) {
    return null;
  }

  return (
    <div className="cookie-window">
      <div className="cookie-window__cont">
        <div className="cookie-window__close" onClick={handleCloseCookie}></div>
        <div className="cookie-window__tabs">
          <div className="cookie-window__tabs-head">
            <div className="cookie-window__tabs-title">Cookies:</div>
            <ul className="cookie-window__tabs-list js-tabs-cookie">
              <li className={activeTab === "tab-cookie-1" ? "active" : ""}>
                <a
                  href="#tab-cookie-1"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("tab-cookie-1");
                  }}
                >
                  Consent
                </a>
              </li>
              <li className={activeTab === "tab-cookie-2" ? "active" : ""}>
                <a
                  href="#tab-cookie-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("tab-cookie-2");
                  }}
                >
                  Details
                </a>
              </li>
              <li className={activeTab === "tab-cookie-3" ? "active" : ""}>
                <a
                  href="#tab-cookie-3"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("tab-cookie-3");
                  }}
                >
                  About
                </a>
              </li>
            </ul>
          </div>
          <div className="cookie-window__tabs-cont-wrap">
            <div
              className={`cookie-window__tabs-cont ${
                activeTab === "tab-cookie-1" ? "" : "hide"
              }`}
              id="tab-cookie-1"
              data-lenis-prevent
            >
              <div className="cookie-window__tabs-cont-text">
                <p>
                  Welcome to D.Trading
                  <br />
                  We use cookies to ensure the security and proper functioning
                  of our website, to analyze traffic and improve user
                  experience. Our cookies include security protection (DDoS and
                  CSRF), analytics tools (Google Analytics, Microsoft Clarity),
                  and marketing services (Google Ads). By clicking "Accept all",
                  you consent to the use of all cookies. You can review detailed
                  information about each cookie in the "Details" tab.
                </p>
              </div>
            </div>
            <div
              className={`cookie-window__tabs-cont ${
                activeTab === "tab-cookie-2" ? "" : "hide"
              }`}
              id="tab-cookie-2"
              data-lenis-prevent
            >
              <ul className="cookie-accordion-list">
                <li
                  className={`cookie-accordion-list__item ${
                    activeCategory === 0 ? "active" : ""
                  }`}
                >
                  <div className="cookie-accordion-list__item-title">
                    <div className="cookie-accordion-list__item-text">
                      <div className="cookie-accordion-list__item-heading">
                        Necessary (4)
                      </div>
                      <p>
                        Necessary cookies help make a website usable by enabling
                        basic functions like security protection, session
                        management, and fraud prevention. The website cannot
                        function properly without these cookies.
                      </p>
                    </div>
                    <div
                      className="cookie-accordion-list__item-icon"
                      onClick={() => handleCategoryClick(0)}
                    ></div>
                  </div>
                  <div className="cookie-accordion-list__item-open-cont">
                    <ul className="cookie-accordion-list__inner">
                      <li
                        className={`cookie-accordion-list__inner-item ${
                          openSubs[0] === 0 ? "active" : ""
                        }`}
                      >
                        <div className="cookie-accordion-list__inner-title">
                          Incapsula Security (2)
                          <div
                            className="cookie-accordion-list__inner-icon"
                            onClick={() => handleSubClick(0, 0)}
                          ></div>
                        </div>
                        <div className="cookie-accordion-list__inner-open-cont">
                          <p>
                            <strong>incap_ses_707_2701289:</strong> Session
                            security cookie for DDoS protection and Web
                            Application Firewall. Maintains HTTP session
                            identification.
                            <br />
                            Maximum Storage Duration: Session (expires when
                            browser closes)
                            <br />
                            Type: HTTP Cookie
                          </p>
                          <p>
                            <strong>visid_incap:</strong> Identifies unique
                            visitors for security purposes and DDoS protection.
                            Automatically renewed on each visit.
                            <br />
                            Maximum Storage Duration: 1 year
                            <br />
                            Type: HTTP Cookie
                          </p>
                        </div>
                      </li>
                      <li
                        className={`cookie-accordion-list__inner-item ${
                          openSubs[0] === 1 ? "active" : ""
                        }`}
                      >
                        <div className="cookie-accordion-list__inner-title">
                          Site Protection (2)
                          <div
                            className="cookie-accordion-list__inner-icon"
                            onClick={() => handleSubClick(0, 1)}
                          ></div>
                        </div>
                        <div className="cookie-accordion-list__inner-open-cont">
                          <p>
                            <strong>site_ses:</strong> CSRF Token Protection
                            cookie. Protects against Cross-Site Request Forgery
                            attacks by containing unique security token.
                            <br />
                            Maximum Storage Duration: 1 day
                            <br />
                            Type: HTTP Cookie
                          </p>
                          <p>
                            <strong>PopUnShown:</strong> Controls the display of
                            the cookie policy notification. Remembers if user
                            has already seen the cookie banner.
                            <br />
                            Maximum Storage Duration: 1 year
                            <br />
                            Type: HTTP Cookie
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
                <li
                  className={`cookie-accordion-list__item ${
                    activeCategory === 1 ? "active" : ""
                  }`}
                >
                  <div className="cookie-accordion-list__item-title">
                    <div className="cookie-accordion-list__item-text">
                      <div className="cookie-accordion-list__item-heading">
                        Analytics (4)
                      </div>
                      <p>
                        Analytics cookies help us understand how visitors
                        interact with our website by collecting and reporting
                        information anonymously. These cookies track page views,
                        user behavior, and session data.
                      </p>
                    </div>
                    <div
                      className="cookie-accordion-list__item-icon"
                      onClick={() => handleCategoryClick(1)}
                    ></div>
                  </div>
                  <div className="cookie-accordion-list__item-open-cont">
                    <ul className="cookie-accordion-list__inner">
                      <li
                        className={`cookie-accordion-list__inner-item ${
                          openSubs[1] === 0 ? "active" : ""
                        }`}
                      >
                        <div className="cookie-accordion-list__inner-title">
                          Google Analytics (2)
                          <div
                            className="cookie-accordion-list__inner-icon"
                            onClick={() => handleSubClick(1, 0)}
                          ></div>
                        </div>
                        <div className="cookie-accordion-list__inner-open-cont">
                          <p>
                            <strong>_ga:</strong> Used to distinguish unique
                            users and sessions. Tracks page views and user
                            behavior across the website.
                            <br />
                            Maximum Storage Duration: 2 years
                            <br />
                            Type: HTTP Cookie
                          </p>
                          <p>
                            <strong>_ga_DRSW3B1WCL:</strong> Google Analytics 4
                            property cookie. Used for session tracking and event
                            data collection.
                            <br />
                            Maximum Storage Duration: 2 years
                            <br />
                            Type: HTTP Cookie
                          </p>
                        </div>
                      </li>
                      <li
                        className={`cookie-accordion-list__inner-item ${
                          openSubs[1] === 1 ? "active" : ""
                        }`}
                      >
                        <div className="cookie-accordion-list__inner-title">
                          Microsoft Clarity (2)
                          <div
                            className="cookie-accordion-list__inner-icon"
                            onClick={() => handleSubClick(1, 1)}
                          ></div>
                        </div>
                        <div className="cookie-accordion-list__inner-open-cont">
                          <p>
                            <strong>_clck:</strong> Microsoft Clarity analytics
                            cookie. Used for session recording and user behavior
                            analysis.
                            <br />
                            Maximum Storage Duration: 1 year
                            <br />
                            Type: HTTP Cookie
                          </p>
                          <p>
                            <strong>_clsk:</strong> Microsoft Clarity session
                            identifier. Tracks individual session data.
                            <br />
                            Maximum Storage Duration: Session (expires when
                            browser closes)
                            <br />
                            Type: HTTP Cookie
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
                <li
                  className={`cookie-accordion-list__item ${
                    activeCategory === 2 ? "active" : ""
                  }`}
                >
                  <div className="cookie-accordion-list__item-title">
                    <div className="cookie-accordion-list__item-text">
                      <div className="cookie-accordion-list__item-heading">
                        Marketing (1)
                      </div>
                      <p>
                        Marketing cookies are used to track visitors across
                        websites. The intention is to display ads that are
                        relevant and engaging for individual users.
                      </p>
                    </div>
                    <div
                      className="cookie-accordion-list__item-icon"
                      onClick={() => handleCategoryClick(2)}
                    ></div>
                  </div>
                  <div className="cookie-accordion-list__item-open-cont">
                    <ul className="cookie-accordion-list__inner">
                      <li
                        className={`cookie-accordion-list__inner-item ${
                          openSubs[2] === 0 ? "active" : ""
                        }`}
                      >
                        <div className="cookie-accordion-list__inner-title">
                          Google Ads (1)
                          <div
                            className="cookie-accordion-list__inner-icon"
                            onClick={() => handleSubClick(2, 0)}
                          ></div>
                        </div>
                        <div className="cookie-accordion-list__inner-open-cont">
                          <p>
                            <strong>_gcl_au:</strong> Used by Google Ads for
                            conversion tracking and campaign attribution. Helps
                            measure the effectiveness of advertising campaigns.
                            <br />
                            Maximum Storage Duration: 3 months
                            <br />
                            Type: HTTP Cookie
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
            <div
              className={`cookie-window__tabs-cont ${
                activeTab === "tab-cookie-3" ? "" : "hide"
              }`}
              id="tab-cookie-3"
              data-lenis-prevent
            >
              <div className="cookie-window__tabs-cont-text">
                <p>
                  <strong>About Cookies</strong>
                  <br />
                  Cookies are small text files that are stored on your device
                  when you visit our website. They help us provide you with a
                  better browsing experience by:
                </p>
                <ul>
                  <li>
                    Ensuring the security and proper functioning of the website
                  </li>
                  <li>
                    Analyzing how visitors use our site to improve user
                    experience
                  </li>
                  <li>
                    Measuring the effectiveness of our marketing campaigns
                  </li>
                </ul>
                <p>
                  You can control and manage cookies through your browser
                  settings. However, please note that disabling certain cookies
                  may affect the functionality and security of the website.
                </p>
                <p>
                  For more detailed information about our use of cookies, please
                  visit our{" "}
                  <a
                    href="/cookie-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cookie Policy
                  </a>{" "}
                  page.
                </p>
              </div>
            </div>
          </div>
          <div className="cookie-window__tabs-btn">
            <a href="#" className="btn-border" onClick={handleAcceptCookies}>
              Accept all
            </a>
            <a href="#" className="btn-border" onClick={handleDeclineCookies}>
              Decline all
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cookie;
